import { useParams } from 'react-router-dom'
import { z } from 'zod'

export function useEncounterIdRouteParam() {
  const params = useParams<{ encounterId: string }>()
  return z.string().parse(params.encounterId)
}
